import React, { useState } from 'react';
import styled from 'styled-components';
import Sidebar from './Sidebar';
import Header from './Header';

const AppContainer = styled.div`
  display: flex;
  height: 100vh;
  background: var(--background);
  color: var(--text-primary);
`;

const ContentWrapper = styled.div`
 flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  width: 100%;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  z-index: 1;
`;

const MainContentWrapper = styled.div`
  flex: 1;
  position: relative;
  overflow: hidden;
  border-radius: 20px 20px 0 0;
`;
const MainContent = styled.main`
  flex: 1;
  overflow-x: hidden;
  background: #f3f5f7;
  height: 100%;
  width: 100%;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
`;

const MaxContainer = styled.div`
  margin: 0 auto;
`;
const Layout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  
  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };
  
  return (
    <AppContainer>
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <ContentWrapper>
        <Header toggleSidebar={toggleSidebar} isSidebarOpen={sidebarOpen} />
        <MainContent>
          <MaxContainer>{children}</MaxContainer>
        </MainContent>
      </ContentWrapper>
    </AppContainer>
  );
};

export default Layout;
